import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, ExternalLink, RefreshCw, Newspaper } from "lucide-react";

export default function NewsPanel({ accent }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [source, setSource] = useState("All");

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/falcon/news?limit=4");
      setItems(r.data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); const t = setInterval(load, 90000); return () => clearInterval(t); }, []);

  const sources = ["All", ...new Set(items.map((x) => x.source))];
  const visible = source === "All" ? items : items.filter((x) => x.source === source);

  return (
    <div className="space-y-4" data-testid="falcon-news">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Newsroom</div>
          <h2 className="font-serif text-3xl mt-1 flex items-center gap-2"><Newspaper className="h-6 w-6" /> Live financial news</h2>
          <div className="text-xs text-muted-foreground mt-1">Aggregated from Reuters, Bloomberg, Al Arabiya, Khaleej Times, FT, Business Daily Africa.</div>
        </div>
        <button onClick={load} data-testid="news-refresh" className="h-9 w-9 inline-flex items-center justify-center rounded-sm border border-border/60 hover:bg-secondary">
          {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />}
        </button>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1">
        {sources.map((s) => (
          <button key={s} onClick={() => setSource(s)} data-testid={`news-src-${s.replace(/\s+/g, "-")}`}
            className={`shrink-0 h-8 px-3 text-xs rounded-sm border transition-colors ${source === s ? "border-foreground bg-card" : "border-border/60 bg-card/40 text-muted-foreground hover:text-foreground"}`}>
            {s}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {visible.slice(0, 20).map((n, i) => (
          <a key={i} href={n.link} target="_blank" rel="noreferrer" data-testid={`news-item-${i}`}
            className="rounded-sm border border-border/60 bg-card p-4 hover:border-foreground/30 transition-colors group">
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider" style={{ color: accent }}>
              <span>{n.source}</span>
              <span className="text-muted-foreground">{n.published?.slice(0, 16)}</span>
            </div>
            <div className="mt-2 font-display text-sm leading-snug group-hover:underline underline-offset-2">{n.title}</div>
            {n.summary && (
              <div className="mt-2 text-xs text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{ __html: n.summary }} />
            )}
            <div className="mt-3 inline-flex items-center gap-1 text-[11px] text-muted-foreground">
              Read on {n.source} <ExternalLink className="h-3 w-3" />
            </div>
          </a>
        ))}
        {visible.length === 0 && !loading && (
          <div className="col-span-2 text-sm text-muted-foreground text-center py-8">No news available right now.</div>
        )}
      </div>
    </div>
  );
}
